var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumbs"},[_c('v-container',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-breadcrumbs',{staticClass:"pl-0",attrs:{"items":_vm.items}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }